import React, { useState } from 'react';
import './Publications.css';

// Journal Papers (from Appendix-1)
const journalPapers = [
  {
    title: "Socialmind: LLM-based Proactive AR Social Assistive System with Human-like Perception for In-situ Live Interactions",
    authors: "Bufang Yang*, Yunqi Guo*, Lilin Xu*, Zhenyu Yan, Hongkai Chen, Guoliang Xing, and Xiaofan Jiang",
    venue: "Proceedings of the ACM on Interactive, Mobile, Wearable and Ubiquitous Technologies",
    year: 2025,
    type: "journal"
  },
  {
    title: "Hybrid Redundancy for Reliable Task Offloading in Collaborative Edge Computing",
    authors: "Hao Guo, Lei Yang*, Qingfeng Zhang, and Jiannong Cao",
    venue: "IEEE Transactions on Computers",
    year: 2025,
    type: "journal"
  },
  {
    title: "Reliable Routing and Scheduling in Time Sensitive Networks based on Reinforcement Learning",
    authors: "Hao Cheng, Lei Yang*, Qingfeng Zhang, and Weiping Zhu*",
    venue: "IEEE Transactions on Network Science and Engineering",
    year: 2025,
    type: "journal"
  },
  {
    title: "Driving State-aware Anomaly Detection for Autonomous Vehicles",
    authors: "Zhihao Wang, Lei Xue*, Xiapu Luo*, Xiaobo Ma, Guofei Gu",
    venue: "IEEE Transactions on Information Forensics and Security",
    year: 2025,
    type: "journal"
  },
  {
    title: "Vehicular Intrusion Detection System for Controller Area Network: A Comprehensive Survey and Evaluation",
    authors: "Yangyang Liu, Lei Xue*, Sishan Wang, Xiapu Luo*, Kaifa Zhao, Pengfei Jing, Xiaobo Ma, Yajuan Tang, Haiying Zhou",
    venue: "IEEE Transactions on Intelligent Transportation Systems",
    year: 2025,
    type: "journal"
  },
  {
    title: "Mitigating Unfairness in Differentially-private Federated Learning",
    authors: "Bingqian Du, Liyao Xiang, Chuan Wu*",
    venue: "ACM Transactions on Modeling and Performance Evaluation of Computing Systems",
    year: 2025,
    type: "journal"
  },
  {
    title: "Towards DS-NER: Unveiling and Addressing Latent Noise in Distant Annotations",
    authors: "Yuyang Ding; Dan Qiao; Juntao Li*; Jiajie Xu; Pingfu Chao; Xiaofang Zhou",
    venue: "IEEE Transactions on Knowledge and Data Engineering",
    year: 2025,
    type: "journal"
  },
  {
    title: "Unifying Lane-Level Traffic Prediction from a Graph Structural Perspective: Benchmark and Baseline",
    authors: "Shuhao Li; Yue Cui; Jingyi Xu; Libin Li; Lingkai Meng; Weidong Yang*, Fan Wang, Xiaofang Zhou",
    venue: "IEEE Transactions on Knowledge and Data Engineering",
    year: 2025,
    type: "journal"
  },
  {
    title: "EdgeShard: Efficient LLM Inference via Collaborative Edge Computing",
    authors: "Mingjin Zhang, Jiannong Cao, Xiaoming Shen, Zeyang Cui",
    venue: "IEEE Internet of Things Journal",
    year: 2024,
    type: "journal" //
  },
  {
    title: "Collaborative Edge Intelligence for Autonomous Vehicles: Opportunities and Challenges",
    authors: "Luyao Bai, Jiannong Cao, Mingjin Zhang, Bo Li",
    venue: "IEEE Network",
    year: 2024,
    type: "journal"
  },
  {
    title: "Distributed Machine Learning in Edge Computing: Challenges, Solutions and Future Directions",
    authors: "Jingke Tu, Lei Yang, Jiannong Cao",
    venue: "ACM Computing Surveys",
    year: 2024,
    type: "journal"
  },
  {
    title: "Federated Class-Incremental Learning with Dynamic Feature Extractor Fusion",
    authors: "Yanyan Lu, Lei Yang, Hao-Rui Chen, Jiannong Cao, Wanyu Lin, Saiqin Long",
    venue: "IEEE Transactions on Mobile Computing",
    year: 2024,
    type: "journal"
  },
  {
    title: "Decentralized Task Offloading in Edge Computing: An Offline-to-Online Reinforcement Learning Approach",
    authors: "Hongcai Lin, Lei Yang, Hao Guo, Jiannong Cao",
    venue: "IEEE Transactions on Computers",
    year: 2024,
    type: "journal" //
  },
  {
    title: "Distribute Semi-Supervised Learning with Consensus Consistency on Edge Devices",
    authors: "Haorui Chen, Lei Yang, Xinglin Zhang, Jiaxing Shen, Jiannong Cao",
    venue: "IEEE Transactions on Parallel and Distributed Systems",
    year: 2024,
    type: "journal"
  },
  {
    title: "Joint Optimization of Pricing, Dispatching and Repositioning in Ride-Hailing with Multiple Models Interplayed Reinforcement Learning",
    authors: "Zhongyun Zhang, Lei Yang, Jiajun Yao, Chao Ma, Jianguo Wang",
    venue: "IEEE Transactions on Knowledge and Data Engineering",
    year: 2024,
    type: "journal"
  }
];

// Conference Papers (from Appendix-2)
const conferencePapers = [
  {
    title: "Ultra-Flexible, Explainable, and Scalable Traffic Prediction with Dynamic Future Route",
    authors: "Zizhuo Xu, Lei Li, Mengxuan Zhang, Yehong Xu, Xiaofang Zhou",
    venue: "41st IEEE International Conference on Data Engineering (ICDE)",
    year: 2025,
    type: "conference"
  },
  {
    title: "A Just-In-Time Framework for Routing-Oriented Traffic Prediction",
    authors: "Jing Zhao, Lei Li, Mengxuan Zhang, Haolun Ma, Xiaofang Zhou",
    venue: "41st IEEE International Conference on Data Engineering (ICDE)",
    year: 2025,
    type: "conference"
  },
  {
    title: "Scalable Graph-based Retrieval-Augmented Generation via Locality-Sensitive Hashing",
    authors: "Fangyuan Zhang, Zhengjun Huang, Yingli Zhou, Qingtian Guo, Wensheng Luo, Xiaofang Zhou",
    venue: "51st International Conference on Very Large Data Bases (VLDB)",
    year: 2025,
    type: "conference"
  },
  {
    title: "COCA: Generative Root Cause Analysis for Distributed Systems with Code Knowledge",
    authors: "Yichen Li, Yulun Wu, Jinyang Liu, Zhihan Jiang, Zhuangbin Chen, Guangba Yu, Michael R. Lyu",
    venue: "2025 IEEE/ACM 47th International Conference on Software Engineering (ICSE)",
    year: 2025,
    type: "conference"
  },
  {
    title: "On the Resilience of LLM-Based Multi-Agent Collaboration with Faulty Agents",
    authors: "Jen-tse Huang, Jiaxu Zhou, Tailin Jin, Xuhui Zhou, Zixi Chen, Wenxuan Wang, Youliang Yuan, Michael R. Lyu, Maarten Sap",
    venue: "Forty-second International Conference on Machine Learning (ICML)",
    year: 2025,
    type: "conference"
  },
  {
    title: "Distinguishability-guided Test Program Generation for WebAssembly Runtime Performance Testing",
    authors: "Shuyao Jiang; Ruiying Zeng; Yangfan Zhou; Michael R. Lyu",
    venue: "2025 IEEE International Conference on Software Analysis, Evolution and Reengineering (SANER)",
    year: 2025,
    type: "conference"
  },
  {
    title: "TaskSense: A Translation-like Approach for Tasking Heterogeneous Sensor Systems with LLMs",
    authors: "Kaiwei Liu, Bufang Yang, Lilin Xu, Yunqi Guo, Guoliang Xing, Xian Shuai, Xiaozhe Ren, Xin Jiang, Zhenyu Yan",
    venue: "ACM Conference on Embedded Networked Sensor Systems 2025 (SenSys)",
    year: 2025,
    type: "conference"
  },
  {
    title: "Automated Soundness and Completeness Vetting of Polygon zkEVM",
    authors: "Xinghao Peng, Zhiyuan Sun, Kunsong Zhao, Zuchao Ma, Zihao Li, Jinan Jiang, Xiapu Luo",
    venue: "The 34th USENIX Security Symposium",
    year: 2025,
    type: "conference"
  },
  {
    title: "Error Messages to Fuzzing: Detecting XPS Parsing Vulnerabilities in Windows Printing Components",
    authors: "Yunpeng Tian, Feng Dong, Junhai Wang, Mu Zhang, Zhiniang Peng, Zesen Ye, Xiapu Luo, Haoyu Wang",
    venue: "The 32nd ACM Conference on Computer and Communications Security (CCS)",
    year: 2025,
    type: "conference"
  },
  {
    title: "SAILS: A Synchronous Accessible Immersive Online Learning System for Young Learners",
    authors: "Yuran Sun, Zhuoying Zhang, Zhenxiao Luo, Alan William Dougherty, Man Ho Yip, Yi King Choi, Chuan Wu",
    venue: "The 16th ACM Multimedia Systems Conference (MMSys)",
    year: 2025,
    type: "conference"
  },
  {
    title: "Explicitly Guided Difficulty-Controllable Visual Question Generation",
    authors: "Jiayuan Xie, Mengqiu Cheng, Xinting Zhang, Yi Cai, Guimin Hu, Mengying Xie, Qing Li",
    venue: "The 39th Annual AAAI Conference on Artificial Intelligence (AAAI)",
    year: 2025,
    type: "conference"
  },
  {
    title: "Efficient Robustness Evaluation via Constraint Relaxation",
    authors: "Chao Pan, Yu Wu, Ke Tang, Qing Li, Xin Yao",
    venue: "The 39th Annual AAAI Conference on Artificial Intelligence (AAAI)",
    year: 2025,
    type: "conference"
  },
  {
    title: "A Picture Is Worth a Graph: A Blueprint Debate Paradigm for Multimodal Reasoning",
    authors: "Changmeng Zheng, Dayong Liang, Wengyu Zhang, Xiao-Yong Wei, Tat-Seng Chua, Qing Li",
    venue: "The 32nd ACM International Conference on Multimedia (ACMMM)",
    year: 2024,
    type: "conference"
  },
  {
    title: "Prior Knowledge Integration via LLM Encoding and Pseudo Event Regulation for Video Moment Retrieval",
    authors: "Yiyang Jiang, Wengyu Zhang, Xulu Zhang, Xiao-Yong Wei, Chang Wen Chen, Qing Li",
    venue: "The 32nd ACM International Conference on Multimedia (ACMMM)",
    year: 2024,
    type: "conference"
  },
  {
    title: "Generative Active Learning for Image Synthesis Personalization",
    authors: "Xulu Zhang, Wengyu Zhang, Xiaoyong Wei, Jinlin Wu, Zhaoxiang Zhang, Zhen Lei, Qing Li",
    venue: "The 32nd ACM International Conference on Multimedia (ACMMM)",
    year: 2024,
    type: "conference"
  },
  {
    title: "PASTA: Training Acceleration for Vertical Federated Learning via Adaptive Pipeline Parallelism",
    authors: "Tian Wu, Weijie Liu, Han Liang, Ziwei Zhan, Jingpu Duan, Chuan Wu, Jinhang Zuo, Xu Chen, Xiaoxi Zhang",
    venue: "IEEE Cluster",
    year: 2025,
    type: "conference"
  },
  {
    title: "Janus: Collaborative Vision Transformer Under Dynamic Network Environment",
    authors: "Linyi Jiang; Silvery D. Fu; Yifei Zhu; Bo Li",
    venue: "IEEE International Conference on Computer Communications",
    year: 2025,
    type: "conference"
  },
  {
    title: "PolyEdge: A Blockchain-based Decentralized Edge AI Platform",
    authors: "Hongbo Liu, Jiannong Cao, Bo Yang,Dongbin Bai, Yinfeng Cao, Xiaoming Shen, Yinan Zhang, Jinwen Liang, Shan Jiang, Mingjin Zhang",
    venue: "IEEE International Conference on Blockchain",
    year: 2025,
    type: "conference"
  },
];

// Priority publications in specified order
const priorityPublications = [
  // 1. EdgeShard: Efficient LLM Inference via Collaborative Edge Computing
  {
    title: "EdgeShard: Efficient LLM Inference via Collaborative Edge Computing",
    authors: "Mingjin Zhang, Jiannong Cao, Xiaoming Shen, Zeyang Cui",
    venue: "IEEE Internet of Things Journal",
    year: 2024,
    type: "journal"
  },
  // 2. PolyEdge: A Blockchain-based Decentralized Edge AI Platform
  {
    title: "PolyEdge: A Blockchain-based Decentralized Edge AI Platform",
    authors: "Hongbo Liu, Jiannong Cao, Bo Yang,Dongbin Bai, Yinfeng Cao, Xiaoming Shen, Yinan Zhang, Jinwen Liang, Shan Jiang, Mingjin Zhang",
    venue: "IEEE International Conference on Blockchain",
    year: 2025,
    type: "conference"
  },
  // 3. Decentralized Task Offloading in Edge Computing: An Offline-to-Online Reinforcement Learning Approach
  {
    title: "Decentralized Task Offloading in Edge Computing: An Offline-to-Online Reinforcement Learning Approach",
    authors: "Hongcai Lin, Lei Yang, Hao Guo, Jiannong Cao",
    venue: "IEEE Transactions on Computers",
    year: 2024,
    type: "journal"
  },
  // 4. Janus: Collaborative Vision Transformer Under Dynamic Network Environment
  {
    title: "Janus: Collaborative Vision Transformer Under Dynamic Network Environment",
    authors: "Linyi Jiang; Silvery D. Fu; Yifei Zhu; Bo Li",
    venue: "IEEE International Conference on Computer Communications",
    year: 2025,
    type: "conference"
  },
  // 5. PASTA: Training Acceleration for Vertical Federated Learning via Adaptive Pipeline Parallelism
  {
    title: "PASTA: Training Acceleration for Vertical Federated Learning via Adaptive Pipeline Parallelism",
    authors: "Tian Wu, Weijie Liu, Han Liang, Ziwei Zhan, Jingpu Duan, Chuan Wu, Jinhang Zuo, Xu Chen, Xiaoxi Zhang",
    venue: "IEEE Cluster",
    year: 2025,
    type: "conference"
  }
];

// Get priority publication titles for filtering
const priorityTitles = new Set(priorityPublications.map(pub => pub.title));

// Get remaining publications (excluding the priority ones) and sort by year (newest first)
const remainingPublications = [...journalPapers, ...conferencePapers]
  .filter(pub => !priorityTitles.has(pub.title))
  .sort((a, b) => b.year - a.year);

// Combine priority publications first, then remaining publications
const allPublications = [...priorityPublications, ...remainingPublications];

const Publications = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedPubs = showAll ? allPublications : allPublications.slice(0, 5);

  return (
    <section id="research" className="section publications">
      <div className="container">
        <h2 className="section-title">Research Publications</h2>
        <ul className="pub-list">
          {displayedPubs.map((pub, index) => (
            <li key={`${pub.title}-${index}`} className="pub-item">
              <div className="pub-type-badge">{pub.type === 'journal' ? 'Journal' : 'Conference'}</div>
              <h3 className="pub-title">{pub.title}</h3>
              <p className="pub-authors">{pub.authors}</p>
              <p className="pub-venue">{pub.venue} ({pub.year})</p>
            </li>
          ))}
        </ul>
        
        {allPublications.length > 5 && (
          <div className="show-more-container">
            <button 
              className="show-more-btn"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll ? 'Show Less' : `Show More (${allPublications.length - 5} more publications)`}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Publications;
